const $inject = ['$q', '$http', '$filter', 'moment', 'APP_CONFIG'];

const carSearchService = function ($q, $http, $filter, moment, APP_CONFIG) {
  let service = {};

  const DEFAULT_SORT = {
    sortBy: '',
    isReverse: false,
  };

  service.hasResults = false;
  service.resultsMaster = [];
  service.activeFilters = {};
  service.activeSort = DEFAULT_SORT;
  service.results = {
    items: [],
    sorted: [],
    PickUpDate: undefined,
    DropOffDate: undefined,
    SearchIdentifier: undefined,
  };

  service.get = get;
  service.getDetails = getDetails;
  service.getUniqueCategories = getUniqueCategories;
  service.getUniqueClasses = getUniqueClasses;
  service.getUniqueVendors = getUniqueVendors;
  service.getUniqueFuelTypes = getUniqueFuelTypes;
  service.getMaxRate = getMaxRate;
  service.clearResults = clearResults;
  service.setResults = setResults;
  service.getLowestTotal = getLowestTotal;
  service.bulkAddFilters = bulkAddFilters;
  service.filter = filter;
  service.sort = sort;
  service.CarMessages = [];

  function get(query) {
    let deferred = $q.defer();

    service.results.PickUpDate = query.PickUp.Date;
    service.results.DropOffDate = query.DropOff.Date;
    service.results.SearchIdentifier = query.Identifier;

    let params = {
      searchIdentifier: query.Identifier,
      dateFrom: moment(query.PickUp.Date, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
      dateTo: moment(query.DropOff.Date, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
      pickupLocationCode: query.PickUp.Code,
      dropoffLocationCode: query.DropOff.Code,
    };

    if (query.PickUp.Depot && query.PickUp.Depot.Supplier) {
      const depot = query.PickUp.Depot;
      params.supplierCode = depot.Supplier;
      params.pickupLocationCode = depot.FullCode;
    }

    if (query.DropOff.Depot && query.DropOff.Depot.Supplier) {
      const depot = query.DropOff.Depot;
      params.supplierCode = depot.Supplier;
      params.dropoffLocationCode = depot.FullCode;
    }

    let carsUrl = APP_CONFIG.MOCK_DATA.active ? APP_CONFIG.MOCK_DATA.cars : APP_CONFIG.api.car;

    $http
      .get(carsUrl, { params: params })
      .success(function (data) {
        service.CarMessages = data.DisplayMessages;
        deferred.resolve(data.CarResults);
      })
      .error(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function getDetails(query) {
    let deferred = $q.defer();

    let params = {
      currencyCode: query.currencyCode,
      dateFrom: moment(query.dateFrom, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
      dateTo: moment(query.dateTo, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
      dropoffLocationCode: query.dropoffLocationCode,
      pickupLocationCode: query.pickupLocationCode,
      rateCode: query.rateCode,
      searchIdentifier: query.searchIdentifier,
      supplierCode: query.supplierCode,
      vehicleCode: query.vehicleCode,
    };

    let carDetailsUrl = APP_CONFIG.MOCK_DATA.active ? APP_CONFIG.MOCK_DATA.carDetails : APP_CONFIG.api.carDetails;

    $http
      .get(carDetailsUrl, { params: params })
      .success(function (data) {
        deferred.resolve(data);
      })
      .error(function () {
        deferred.reject();
      });

    return deferred.promise;
  }

  function getUniqueCategories(results) {
    const uniqueCategories = _.uniqBy(
      _.compact(
        results.map(function (result) {
          if (!result.Category) {
            return null;
          }

          return { value: result.Category, label: result.Category.trim() };
        })
      ),
      'value'
    );

    return _.orderBy(uniqueCategories, (item) => {
      return item.label;
    });
  }

  function getUniqueClasses(results) {
    const uniqueClasses = _.uniqBy(
      _.compact(
        results.map(function (result) {
          if (!result.Class) {
            return null;
          }

          return { value: result.Class, label: result.Class.trim() };
        })
      ),
      'value'
    );

    return _.orderBy(uniqueClasses, (item) => {
      return item.label;
    });
  }

  function getUniqueVendors(results) {
    const uniqueVendors = _.uniqBy(
      _.compact(
        results.map(function (result) {
          let vendorName = result.Vendor.Title;

          return vendorName ? { value: vendorName, label: vendorName } : null;
        })
      ),
      'value'
    );

    return _.orderBy(uniqueVendors, (item) => {
      return item.label;
    });
  }

  function getUniqueFuelTypes(results) {
    const uniqueFuelTypes = _.uniqBy(
      _.compact(
        results.map(function (result) {
          if (!result.FuelType) {
            return null;
          }

          return { value: result.FuelType, label: result.FuelType.trim() };
        })
      ),
      'value'
    );

    return _.orderBy(uniqueFuelTypes, (item) => {
      return item.label;
    });
  }

  function getMaxRate(results) {
    return Math.ceil(
      _.max(
        _.compact(
          _.map(results, (result) => {
            return result.DailyRate;
          })
        )
      )
    );
  }

  function clearResults() {
    service.hasResults = false;
    service.resultsMaster = [];
    service.results.items = [];
    service.results.from = 0;
  }

  function setResults(results) {
    service.hasResults = true;
    service.resultsMaster = results;
    service.results.recommended = [];
    service.results.items = [];
    service.results.originalItems = [];
    _.forEach(results, (result) => {
      if (result.Recommended) {
        service.results.recommended.push(result);
      } else {
        service.results.items.push(result);
        service.results.originalItems.push(result);
      }
    });
  }

  function getLowestTotal() {
    let cheapestCar = _.min(service.resultsMaster, function (car) {
      return car.Total;
    });

    return Math.round(cheapestCar.Total);
  }

  function bulkAddFilters(filters) {
    _.forOwn(filters, (filter, key) => {
      service.activeFilters[key] = filter;
    });

    filter();
  }

  function filter() {
    process();
  }

  function sort(orderBy, isReverse) {
    if (!orderBy) {
      service.activeSort = DEFAULT_SORT;
    } else {
      service.activeSort = { orderBy, isReverse };
    }

    process();
  }

  function process() {
    let processedResults = angular.copy(service.results.originalItems);

    _.forOwn(service.activeFilters, (filter) => {
      if (filter.settings.isActive()) {
        processedResults = $filter(filter.filterName)(processedResults, filter.settings);
      }
    });

    service.results.items = $filter('orderBy')(processedResults, service.activeSort.orderBy, service.activeSort.isReverse);
  }

  /*function applyFilters() {
    let filteredResults = service.results.master;

    Object.keys(service.results.activeFilters).forEach(filter => {
      const filterSettings = service.results.activeFilters[filter];

      if(filter === 'Price') {
        let priceFilterSettings = filterSettings[0];

        if(priceFilterSettings.minValue > priceFilterSettings.defaultMin || priceFilterSettings.maxValue < priceFilterSettings.defaultMax) {
          filteredResults = $filter('withinRangeFilter')(filteredResults, priceFilterSettings);
        }
      } else {
        const activeFilters = _.filter(filterSettings, (setting) => {
          return setting.isActive;
        });

        if(activeFilters.length) {
          filteredResults = $filter('inArrayFilter')(filteredResults, activeFilters);
        }
      }
    });

    service.results.filtered = filteredResults;
  }*/

  return service;
};

carSearchService.$inject = $inject;

export default carSearchService;



// WEBPACK FOOTER //
// ./src/services/carSearchService.js